import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// import VMIDDecoder from './VMIDDecoder';

import DevicesScreen from '../../views/VMlistComponens/Devices/DevicesScreen';
import DeviceDetailer from '../../views/VMlistComponens/DeviceDetailer/DeviceDetailer';


class Vms extends Component {
	render() {
		return (
			<div>
				<Switch>			
					
					<Route
						path="/vms/:vmID/detailer"
						name="Detailer"
						component={DeviceDetailer}
					/>
					<Route path="/vms" name="Vms" component={DevicesScreen} />

					<Redirect from="/" to="/vms" />
				</Switch>
			</div>
		);
	}
}
//<Container fluid>
export default Vms;
